import RestService from "../../../core/services/rest.service";
import type { About } from "~/modules/about/models/About.interface";

class AboutService extends RestService {
  /**
   * Retrieve about with version
   */
  getAbout(): Promise<About> {
    return this.$apiV2.get("about");
  }
}

export default new AboutService();
